// MODULES
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// PAGES
import { HomeComponent } from '@pages/home/home.component';
import { ProductsDetailComponent } from '@pages/products-detail/products-detail.component';
import { BrandsComponent } from '@pages/brands/brands.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';

const routes: Routes = [
  { path: "", component: HomeComponent },
  { path: "home", component: HomeComponent },
  { path: "products/:detail", component: ProductsDetailComponent },
  { path: "brands", component: BrandsComponent },
  { path: "**", component: NotFoundComponent },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
